import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StandardDeviationService {

  // https://stackoverflow.com/questions/7343890/standard-deviation-javascript/77664868#77664868
  standardDeviation(
    array: number[],
  ): number | undefined {
    const n: number = array.length;
    if (n === 0) {
      return undefined;
    }
    const mean: number = this.mean(array);
    return Math.sqrt(array
      .map(x => Math.pow(x - mean, 2))
      .reduce((a, b) => a + b) / n);
  }
  mean(
    array: number[],
  ): number {
    if (!array.length) {
      return 0;
    }
    const n: number = array.length;
    const mean: number = array.reduce((a, b) => a + b) / n;
    return mean;
  }

  incrementsFromMean(
    array: number[],
  ): number[] {
    const standardDeviation: number | undefined = this.standardDeviation(array);
    const mean: number = this.mean(array);
    const increments: number[] = [];
    array.forEach(num => {
      let increment: number = 0;
      if (
        standardDeviation !== undefined &&
        standardDeviation > 0
      ) {
        increment = Math.abs(num - mean) / standardDeviation;
      }
      if (
        num > mean ||
        increment === 0
      ) {
        increments.push(increment);
      } else {
        increments.push(-increment);
      }
    });
    return increments;
  }
}
